import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CategoriesOfVacancyPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const getData = (count = 5, offset = 0) => {
    apiRequests.hr.getCategories(count, offset).then((res) => setData(res));
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.hr.getCategoriesFiltered(searchValue).then((res) => setData(res));
    }
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.hr.deleteCategory(id).then(() =>
      setData((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink="/HR/categories/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`/HR/categories/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={data.totalCount}
        itemsPerPage={5}
        onChange={(page) => getData(5, 5 * page)}
      />
    </>
  );
};

export default CategoriesOfVacancyPage;
